//import $ from 'jquery';
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class User2Sorter extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;
        this.ToggleSorter = this.ToggleSorter.bind(this);
        this.ShowUser = this.ShowUser.bind(this);
        this.Save = this.Save.bind(this);

        this.state = {
            Users: Comm.Users(sid),
            SelectedUser: null,
        };
    }

    ShowUser(user) {
        console.log("user", user);
        let dta = {
            session: Context.GetContext().Sid,
            user_id: user.id,
        };
        let userData = Comm.CallServerFunction("scales/user_sorters", dta);
        userData.user_id = user.id;
        this.setState({ SelectedUser: userData });
    }

    ToggleSorter(sorterId) {
        let element = this.state.SelectedUser.rows.find((x) => x.sorter === sorterId);
        element.checked = !element.checked;
        console.log("this.state.SelectedUser", this.state.SelectedUser);
        this.setState({ SelectedUser: JSON.parse(JSON.stringify(this.state.SelectedUser)) });
    }

    Save() {
        let self = this;
        let sid = Context.GetContext().Sid;
        let sorters = [];
        for (let s of this.state.SelectedUser.rows.filter((x) => x.checked)) {
            sorters.push({ sorter: s.sorter });
        }

        let dta = {
            session: sid,
            user_id: self.state.SelectedUser.user_id,
            sorters: JSON.stringify(sorters),
        };

        Comm.CallServerFunction("scales/save_user_sorters", dta);
        this.setState({
            Users: Comm.Users(sid),
            SelectedUser: null,
        });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        var self = this;
        if (Context.RenderNotOK(this.props.history)) return null;

        var users = this.state.Users.slice();

        return Context.HasRight("rusers") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("users")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-2">
                            {users.map((obj) => (
                                <p
                                    className={
                                        this.state.SelectedUser != null &&
                                        this.state.SelectedUser.id === obj.id
                                            ? "btn btn-warning"
                                            : null
                                    }
                                >
                                    <a onClick={() => this.ShowUser(obj)} className="pointhand">
                                        {obj.username}
                                    </a>
                                </p>
                            ))}
                        </div>
                        <div className="col-md-10">
                            {this.state.SelectedUser !== null && (
                                <div className="borderDiv">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button
                                                className="btn btn-primary pull-right"
                                                onClick={() => this.Save()}
                                            >
                                                {Translation.Trans("save")}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {this.state.SelectedUser.rows.map((i) => (
                                                <p KEY={i.sorter}>
                                                    <input
                                                        type="checkbox"
                                                        checked={i.checked}
                                                        onChange={() => self.ToggleSorter(i.sorter)}
                                                    />
                                                    <label>{i.name}</label>
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default User2Sorter;



// WEBPACK FOOTER //
// ./src/pages/user2sorter.js